module.exports = __webpack_public_path__ + "static/img/ybm.18cd055.png";


//////////////////
// WEBPACK FOOTER
// ./image/mobile/auditState/ybm.png
// module id = 172
// module chunks = 502